/** Number of alternative-date rows offered next to the main booking date */
export const ALTERNATIVE_DATES_COUNT = 3
